export default __webpack_public_path__ + "static/media/view_gr_middle.0bd80a13.png";